import { render, staticRenderFns } from "./Gop.vue?vue&type=template&id=39a1871a&scoped=true&"
import script from "./Gop.vue?vue&type=script&lang=js&"
export * from "./Gop.vue?vue&type=script&lang=js&"
import style0 from "./Gop.vue?vue&type=style&index=0&id=39a1871a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1871a",
  null
  
)

export default component.exports